import { render } from "./OrdersList.vue?vue&type=template&id=8ed27d5a&scoped=true"
import script from "./OrdersList.vue?vue&type=script&lang=js"
export * from "./OrdersList.vue?vue&type=script&lang=js"

import "./OrdersList.vue?vue&type=style&index=0&id=8ed27d5a&lang=less&scoped=true"
import "./OrdersList.vue?vue&type=style&index=1&id=8ed27d5a&scoped=true&lang=css"
import "./OrdersList.vue?vue&type=style&index=2&id=8ed27d5a&lang=css"
import "./OrdersList.vue?vue&type=style&index=3&id=8ed27d5a&lang=css"
import "./OrdersList.vue?vue&type=style&index=4&id=8ed27d5a&lang=css"
import "./OrdersList.vue?vue&type=style&index=5&id=8ed27d5a&lang=css"
import "./OrdersList.vue?vue&type=style&index=6&id=8ed27d5a&lang=css"
import "./OrdersList.vue?vue&type=style&index=7&id=8ed27d5a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ed27d5a"]])

export default __exports__